import { Fetchable, Paginated, Seat } from "../../interfaces";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Beach } from "../../interfaces";

export interface BeachState {
  allBeaches: Partial<Fetchable<Paginated<Beach>>>;
  beach: Partial<Fetchable<Beach>>;
  createdBeach: Partial<Fetchable<Beach | Beach[]>>;
  updatedBeach: Partial<Fetchable<Beach>>;
  deletedBeach: Partial<Fetchable<Beach>>;
}

const initialState: BeachState = {
  allBeaches: {},
  beach: {},
  createdBeach: {},
  updatedBeach: {},
  deletedBeach: {},
};

export const beachSlice = createSlice({
  name: "beach",
  initialState,
  reducers: {
    setError: (
      state,
      action: PayloadAction<{
        fetchableProp: keyof BeachState;
        error: any;
      }>
    ) => {
      state[action.payload.fetchableProp].error = action.payload.error;
    },
    clear: (state, action: PayloadAction<keyof BeachState>) => {
      state[action.payload] = {};
    },
    setLoader: (
      state,
      action: PayloadAction<{
        fetchableProp: keyof BeachState;
        isLoading: boolean;
      }>
    ) => {
      state[action.payload.fetchableProp].isLoading = action.payload.isLoading;
    },
    // PAGINATED GET
    setPaginatedBeaches: (state, action: PayloadAction<Paginated<Beach>>) => {
      state.allBeaches.data = action.payload;
      state.updatedBeach.error = undefined;
    },
    // GET
    setBeach: (state, action: PayloadAction<Beach>) => {
      state.beach.data = action.payload;
      state.updatedBeach.error = undefined;
    },
    // CREATE
    createBeach: (state, action: PayloadAction<Beach>) => {
      state.beach.data = action.payload;
      state.beach.data.seats = [];
      state.updatedBeach.error = undefined;
    },
    // UPDATE
    updateBeach: (state, action: PayloadAction<Beach>) => {
      state.updatedBeach.data = action.payload;
      state.beach.data = {
        ...state.beach.data,
        ...action.payload,
      };

      if (!state.updatedBeach.data.seats) {
        state.updatedBeach.data.seats = [];
      }
      state.updatedBeach.error = undefined;
    },
    // DELETE
    deleteBeach: (state, action: PayloadAction<Beach>) => {
      state.deletedBeach.data = action.payload;
      state.updatedBeach.error = undefined;
      if (state.beach.data) {
        state.beach.data.seats = state.beach.data?.seats?.filter(
          (f) => f.id !== action.payload
        );
      }
    },

    updateSeat: (state, action: PayloadAction<Seat>) => {
      if (state.beach.data && state.beach.data.seats) {
        const seatFoundIndex = state.beach.data.seats.findIndex(
          (f) => f.id === action.payload.id
        );
        state.beach.data.seats[seatFoundIndex] = action.payload;
      }
    },

    createSeat: (state, action: PayloadAction<Seat>) => {
      if (state.beach.data && state.beach.data.seats) {
        state.beach.data.seats = state.beach.data.seats.concat(action.payload);
      }
    },
    deleteSeat: (state, action: PayloadAction<string>) => {
      if (state.beach.data && state.beach.data.seats) {
        state.beach.data.seats = state.beach.data.seats.filter(
          (w) => w.id !== action.payload
        );
      }
    },
  },
});

const actions = { ...beachSlice.actions };

export { actions };
export default beachSlice.reducer;
